import { useSite } from "../context/SiteContext";
import { bust } from "../lib/img";

export const MenuItemCard = ({ item, variant = "" }) => {
  const { localName, localDesc } = useSite();

  return (
    <article className={`dish-card group ${variant}`} data-testid={`menu-item-${item.id}`}>
      {item.image && (
        <div className="dish-media">
          <img src={bust(item.image)} alt={localName(item)} loading="lazy" />
          <h3 className="dish-title">{localName(item)}</h3>
        </div>
      )}
      <div className="dish-body">
        <div className="dish-rule" />
        <p className="dish-desc line-clamp-3">{localDesc(item)}</p>
      </div>
    </article>
  );
};
